export default __webpack_public_path__ + "static/media/choose_subject_background.4e008773.png";